import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { CreateAssistantPopup } from "./CreateAssistantPopUp";
import { MicIcon } from "../../Assets/svgs/micIcon";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { ALL_VOICE_PROVIDERS } from "../../Common/Constants";
import { getAssistantsCount } from "../../Redux/Slice/Assistant/GetAssistantCountSlice";

export const AssistantsListSidebar = ({
  changeSelection,
  onClickCreateAssistant,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const hasUnsavedChanges = useSelector(
    (state) => state.hasUnsavedChanges.hasUnsavedChanges
  );
  const customerId = location.pathname.includes("/add-assistant/")
    ? location.pathname.split("/")[2]
    : "";
  const [selected, setselectedRow] = useState("");
  const [assistants, setAssistants] = useState([]);
  const [showWarning, setWarning] = useState(false);
  const [editSelection, setEditSelection] = useState();
  const [showEditWarning, setEditWarning] = useState(false);
  const [addAssistant, setAddAssistant] = useState(false);
  const isMetaAssistant = location.pathname == "/add-meta-assistant";
  const assistantListData = useSelector(
    (state) => state.assistants.assistantsList
  );
  useEffect(() => {
    getAssistantListFunc();
    if (location?.state?.from === "new") {
      setselectedRow({ name: location.state?.name });
    } else if (location?.state?.from === "template") {
      setselectedRow({
        name: location.state?.name,
        ...location.state?.details,
      });
    } else {
      setselectedRow({ id: location.state?.selectedBotId });
    }
  }, [location.state]);

  const getAssistantListFunc = async () => {
    dispatch(getAssistantsCount());
    const result = await dispatch(getAssistantList({ text: "", customerId }));
  };
  const onAddConfirm = () => {
    setWarning(false);
    setAddAssistant(true);
  };
  const popUpClose = () => {
    setAddAssistant(false);
  };
  const onEditConfirm = () => {
    setEditWarning(false);
    dispatch(setUnsavedChanges(false));
    setselectedRow({ id: editSelection.id, name: editSelection.name });
    location.state = {
      from: "edit",
      selectedBotId: editSelection.id,
      name: editSelection.name,
    };
    changeSelection(editSelection);
  };

  useEffect(() => {
    if (assistantListData && Array.isArray(assistantListData?.data)) {
      setAssistants(assistantListData?.data);
    }
  }, [assistantListData]);

  const getVoiceName = (voiceProvider, voiceName) => {
    const currentVoiceProvider = ALL_VOICE_PROVIDERS.find(
      (i) => i?.value === voiceProvider
    );
    if (currentVoiceProvider) {
      const voice = currentVoiceProvider?.voiceId.find(
        (i) => i?.value === voiceName
      );
      return voice ? voice?.label : voiceName;
    }
    return voiceName ?? "";
  };

  return (
    <div className="createAssistantMain__col h_100">
      {showWarning ? (
        <ConfirmModel
          onAccept={onAddConfirm}
          onReject={() => {
            setWarning(false);
          }}
          title="Add Assistant!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {showEditWarning ? (
        <ConfirmModel
          onAccept={onEditConfirm}
          onReject={() => {
            setEditWarning(false);
          }}
          title="Edit Assistant!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {addAssistant ? <CreateAssistantPopup setPopUp={popUpClose} /> : ""}
      <div className="createAssistantMain__card h_100">
        <div
          className="btn__group btn__group--directionColumn"
          style={{
            overflowY: "auto",
            height: "100%",
            paddingRight: "0.5rem",
          }}
        >
          {!isMetaAssistant ? (
            <button
              className="btn btn__primary btn__outlined btn--full"
              onClick={onClickCreateAssistant}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00008 1.16699V12.8337M1.16675 7.00033H12.8334"
                  stroke="#8b58f1"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Create New Assistant
            </button>
          ) : null}
          {location?.state?.from != "edit" ? (
            <button className="btn btn--fontDeskVoicebot btn__primary btn--full">
              {location?.state?.name ?? selected.name}
              <span className="info">
                {selected?.voice?.voiceId ? selected?.voice?.voiceId : ""}
                <MicIcon />
              </span>
            </button>
          ) : (
            ""
          )}
          {assistants
            ? assistants.map((assistant) => {
                return (
                  <button
                    className={
                      selected.id === assistant.id
                        ? "btn btn--fontDeskVoicebot btn__primary btn--full"
                        : "btn btn--fontDeskVoicebot btn__white btn--full"
                    }
                    onClick={() => {
                      if (location.state.from != "edit" || hasUnsavedChanges) {
                        setEditWarning(true);
                        setEditSelection(assistant);
                      } else {
                        setselectedRow({ id: assistant.id });
                        changeSelection(assistant);
                      }
                    }}
                  >
                    {assistant.name}
                    <span className="info">
                      {getVoiceName(
                        assistant?.voice?.provider,
                        assistant?.voice?.voiceId
                      )}
                      <MicIcon
                        color={selected.id === assistant.id ? "white" : "#111"}
                      />
                    </span>
                  </button>
                );
              })
            : ""}
        </div>
      </div>
    </div>
  );
};
